/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Message from 'DesignSystem/Message/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Time({
  children,
  viewPath = "/App/Account/CheckedIn/Time"
  
}) {
let checkinUserDataTimeValueData = fromData.useDataFormat({ viewPath,
context: 'checkin',
path: 'user_data.time',
format: fromHelpers.format,
})
  return (<React.Fragment
>
<Message
  viewPath={`${viewPath}/Message`}
 color="#404040"
 textAlign="center"
 data="checkin.user_data.time"
 format="helpers.js format"
 text={checkinUserDataTimeValueData}
 fontWeight={600}
 lineHeight={1.6}
/>
{children}
</React.Fragment>)
}